import { render, staticRenderFns } from "./TodoQuickConfigChildrenDialog.vue?vue&type=template&id=9f520ff8&"
import script from "./TodoQuickConfigChildrenDialog.vue?vue&type=script&lang=js&"
export * from "./TodoQuickConfigChildrenDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports